//合同路由
export default [{
  path: 'bidArchiveList',
  name: 'bidArchiveList',
  component: function component() {
    return import('@/views/bidArchiveManage/redact/index');
  }
}, {
  path: 'bidArchiveAdd',
  name: 'bidArchiveAdd',
  component: function component() {
    return import('@/views/bidArchiveManage/redact/add');
  }
}, {
  path: 'bidArchiveUpdate',
  name: 'bidArchiveUpdate',
  component: function component() {
    return import('@/views/bidArchiveManage/redact/update');
  }
}, {
  path: 'bidArchiveDetails',
  name: 'bidArchiveDetails',
  component: function component() {
    return import('@/views/bidArchiveManage/redact/detail');
  }
}, {
  path: 'bidArchiveReviewList',
  name: 'bidArchiveReviewList',
  component: function component() {
    return import('@/views/bidArchiveManage/review/index');
  }
}, {
  path: 'bidArchiveReviewDetails',
  name: 'bidArchiveReviewDetails',
  component: function component() {
    return import('@/views/bidArchiveManage/review/detail');
  }
}, {
  path: 'bidArchiveStatisticsList',
  name: 'bidArchiveStatisticsList',
  component: function component() {
    return import('@/views/bidArchiveManage/statistics/index');
  }
}];